import React, {Component} from 'react';
import PropTypes from "prop-types";
import InputField from "./InputField";
import StaticFunctions from "./StaticFunctions";

class ConfirmPasswordFields extends Component {

    static propTypes = {
        label1: PropTypes.string.isRequired,
        label2: PropTypes.string.isRequired,
        className1: PropTypes.string.isRequired,
        className2: PropTypes.string.isRequired,
        onConfirm: PropTypes.func.isRequired,
    };

    static defaultProps = {
        required: true,
    };

    constructor(props) {

        super(props);

        this.state = {
            password: '',
            securityLevel: null,
        };

        this.passwordMinLength = 12;

        this.getInput = this.getInput.bind(this);
        this.onValueChange = this.onValueChange.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.validateConfirm = this.validateConfirm.bind(this);
        this.securityLevel = this.securityLevel.bind(this);

    }

    getInput(event, name, value, isValid) {

        if (name === 'password') {
            this.setState({
                password: (isValid) ? value : '',
            });
        } else if (name === 'confirmPassword') {
            if (value !== '' && value === this.state.password) this.props.onConfirm(event, 'password', value, true);
        }

    }

    onValueChange(event, name, value, isValid) {

        this.securityLevel(value);

    }

    onKeyDown(event, name, value, isValid) {

        if (event.keyCode === 27) {

            this.setState({
                securityLevel: null
            });
        }

    }

    validateConfirm(password) {

        return (password !== '' && password === this.state.password);

    }

    securityLevel(password) {

        const securityLevel = StaticFunctions.getSecurityLevelOfPassword(password, this.passwordMinLength);

        if (securityLevel !== this.state.securityLevel) {
            this.setState({
                securityLevel
            });
        }

    }

    render() {

        const securityColor = (this.state.securityLevel !== null) ? {backgroundColor: StaticFunctions.getSecurityColorFromLevel(this.state.securityLevel)} : null;
        const isRequired = (this.props.required === true);

        return (
            <div className="formRow">
                <table>
                    <tbody>
                        <tr>
                            <td className="text-left labelSpan">{this.props.label1}</td>

                            <td className="text-left">
                                <InputField
                                    name="password"
                                    className={this.props.className1}
                                    type="password"
                                    value={this.state.password}
                                    isRequired={isRequired}
                                    onBlur={this.getInput}
                                    onChange={this.onValueChange}
                                    onKeyDown={this.onKeyDown}
                                />

                                <span className="formPwSecIcon" style={securityColor}>&nbsp;</span>
                            </td>
                        </tr>

                        <tr>
                            <td className="text-left labelSpan">{this.props.label2}</td>

                            <td className="text-left">
                                <InputField
                                    name="confirmPassword"
                                    className={this.props.className2}
                                    type="password"
                                    isRequired={isRequired}
                                    validate={this.validateConfirm}
                                    onBlur={this.getInput}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );

    }

}

export default ConfirmPasswordFields;